import { Component, OnInit, ViewChild, Inject, HostListener } from "@angular/core";
import { Constant } from "../core/constant";
import { AdminService } from "../services/admin.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { MatMenuTrigger } from "@angular/material/menu";
import { Router } from "@angular/router";
import { UserList } from "../models/user-list";
import { User } from "../models/user";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { CryptographyService } from "../services/cryptography.service";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { CustomEventNRService } from "../services/custom-event-nr.service";

@Component({
  selector: "app-view-all-user-list",
  templateUrl: "./view-all-user-list.component.html",
  styleUrls: ["./view-all-user-list.component.scss"],
})
export class ViewAllUserListComponent implements OnInit {
  activePopupId: string | number | null = null;
  loading: boolean = false;
  pageSizes: any[] = Constant.PageSizes;
  searchKey: string = "";
  selectedRole: string = "";

  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  totalPages: number = 0;

  userList: UserList = new UserList();
  error: string = "";
  modalOption: NgbModalOptions = {};
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;

  constructor(
    private adminService: AdminService,
    private ngbModal: NgbModal,
    private router: Router,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private customEventNRService: CustomEventNRService,
  ) {}

  ngOnInit() {
    this.getUsers();
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.getUsers();
  }

  getUsers(): void {
    this.loading = true;
    this.adminService
      .GetUserList(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.searchKey
      )
      .subscribe(
        (data: any) => {
          this.userList.users = (data.users || []).map((o) => {
            o.country = o.countries ? o.countries.map((c) => c.country) : [];
            o.countryId = o.countries ? o.countries.map((c) => c.countryId) : [];
            return new User(o);
          });
          this.collectionSize = data.count;
          this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
          if (this.searchKey) {
            this.customEventNRService.sendSearchEvent(
              "GrsSearchEvents",
              this.searchKey,
              this.collectionSize,
              window.location.href
            );
          }
          this.loading = false;
        },
        (error: string) => {
          this.error = error;
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error;
          this.loading = false;
        }
      );
  }

  addSearchKey(searchKey: string) {
    this.searchKey = searchKey;
    this.page = 1;
    this.getUsers();
  }

  getUserFullName(item: any): string {
    if (!item) return "";
    const first = item.name || "";
    const last = item.lastName || "";
    const full = `${first} ${last}`.trim();
    return full || item.email || "";
  }

  getCommaSeperatedCountries(countries: any[]): string {
    if (!countries || countries.length === 0) return "-";
    const countryNames = countries
      .map((c) => (c ? c.name : ""))
      .filter((n) => !!n);
    if (countryNames.length === 0) return "-";
    if (countryNames.length === 1) return countryNames[0];
    if (countryNames.length === 2) return countryNames.join(", ");
    return `${countryNames.slice(0, 2).join(", ")} +${countryNames.length - 2}`;
  }

  togglePopup(event: Event, item: any) {
    event.stopPropagation();
    const id = item.id;
    this.activePopupId = this.activePopupId === id ? null : id;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".grid-actions")) {
      this.activePopupId = null;
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.getUsers();
    }
  }

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.getUsers();
    }
  }

  onAddEditUser(userd: number = null) {
    if (!userd) {
      this.router.navigate(["/add-user"]);
    } else {
      this.router.navigate(["/add-user/" + userd]);
    }
  }

  onEdit(item: any, event: Event) {
    event.stopPropagation();
    this.activePopupId = null;
    this.onAddEditUser(item.id);
  }

  actionMenuOpen(event: Event) {
    event.stopPropagation();
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    if (this.trigger) {
      this.trigger.closeMenu();
    }
    setTimeout(() => {
      this.openDeleteModal(item, event);
    }, 100);
  }

  openDeleteModal(item, event) {
    event.stopPropagation();
    this.activePopupId = null;
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this user from the list? ";
    modalRef.componentInstance.deleteItem = item;
    modalRef.componentInstance.message =
      "All the dependencies will be removed along with this user";
    if (this.trigger) {
      this.trigger.closeMenu();
    }
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      if (deleteItem != null) {
        let user = new User(item);
        this.loading = true;
        user.modifiedUserId = this.cryptographyService.decryptData(
          this.storage.get("userId")
        );
        this.adminService.DeleteUser(user).subscribe((data: any) => {
          this.loading = false;
          this.page = 1;
          this.getUsers();
        });
      }
      this.ngbModal.dismissAll();
    });
  }
}
